var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('the-layout-portal', [_c('v-container', [_c('m-header', {
    attrs: {
      "breadCrumbs": _vm.breadCrumbList,
      "title": _vm.$t('report.reportGroupTable'),
      "chips": _vm.chips,
      "actions": _vm.actions
    },
    on: {
      "actionClicked": function actionClicked(a) {
        return a.exec();
      }
    }
  }), _c('report-group-table', {
    ref: "reportGroupTable",
    attrs: {
      "partnerId": _vm.partnerId
    },
    on: {
      "openSideCard": _vm.openSideCard
    }
  })], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }